import React, { createContext, useContext, useEffect } from 'react';
import { useDialogState } from 'reakit/Dialog';

export const SidenavDialogContext = createContext(undefined);

const SidenavDialogContextProvider = ({ children }) => {
  const dialog = useDialogState({ animated: true });

  // remove reakit/Dialog body padding
  useEffect(() => {
    if (dialog.visible) {
      document.body.removeAttribute('style');
    }
  }, [dialog]);

  return (
    <SidenavDialogContext.Provider value={dialog}>
      {children}
    </SidenavDialogContext.Provider>
  );
};

export default SidenavDialogContextProvider;

export const useSidenavDialog = () => {
  const sidenavDialog = useContext(SidenavDialogContext);
  if (sidenavDialog === undefined) {
    throw new Error('sidenavDialog must be used within a SidenavDialogContext');
  }
  return sidenavDialog;
};
